// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.c-fullheight[data-v-efdebc78] {\n  height: 100%;\n}\n.c-portal[data-v-efdebc78] {\n  background-color: var(--v-background-base);\n  padding: 8px;\n  border-radius: 4px;\n  margin-bottom: 16px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
